import Request from '../../request';

const BASE_URI_GO_API = process.env.API_PAY + '/api/v1';

const CreateBoleto = async(IDReserva) => {
  return await Request.AxiosAuthPost(`${BASE_URI_GO_API}/ABC/investidor/criar`, {IDReserva})
}

export default { CreateBoleto }


// WEBPACK FOOTER //
// ./src/services/api/iouuPay/index.js